import React, { FC } from 'react';
import AppLayout from '@amzn/meridian/app-layout';
import AgileNavBar from '@components/agile/navigation/AgileNavBar';
import ProgramType from 'src/types/programType';

interface Props {
  children?: React.ReactNode;
  programType: ProgramType;
}

const AgileLayout: FC<Props> = ({ children, programType }) => (
  <AppLayout headerComponent={AgileNavBar} backgroundColor="primary">
    <AgileNavBar programType={programType} />
    {children}
  </AppLayout>
);

export default AgileLayout;
